// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bubblegum+Sans&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: #FFFFFF;
    margin: 0;
}

.nav {
    background-color: #FFFFFF;
    padding: 2rem;
    display: flex;
    align-items: center;
    border-bottom: 1px solid black;
    position: relative;
    margin: 0;
    width: 100vw;
    box-sizing: border-box;
    left: 0;
    right: 0;
}

.nav-logo-container {
    display: flex;
    align-items: center;
    position: absolute;
    left: 1rem;
    top: 0;
}

.nav-logo-container img {
    display: block;
    background: transparent;
}

.company-name {
    font-family: 'Bubblegum Sans', sans-serif;
    font-size: 2rem;
    font-weight: 400;
    color: #2D3E50;
    margin-left: 0.5rem;
}

.nav-links {
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: 1rem;
}

.nav-right {
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: 1rem;
}

.nav-link {
    color: #2D3E50;
    margin: 0 1rem;
    text-decoration: none;
    font-size: 1rem;
}

.nav-link:hover {
    text-decoration: none;
}

.logout-link {
    margin-right: 1rem;
}

.cta-button {
    padding: 0.3rem 1rem;
    border: none;
    border-radius: 8px;
    font-size: 0.7rem;
    font-weight: bold;
    color: white;
    background: linear-gradient(90deg, #ffcc99, #ff9966, #ff66cc, #cc66ff);
    cursor: pointer;
    margin-left: 1rem;
}

.cta-button:hover {
    background: linear-gradient(90deg, #cc66ff, #ff66cc, #ff9966, #ffcc99);
}

/* Hamburger menu styles */
.nav-toggle-label {
    display: none;
    font-size: 1.5rem;
    color: #2D3E50;
    cursor: pointer;
}

.nav-toggle-label.open::after {
    content: "✕";
    font-size: 1.5rem;
}

.header {
    background-color: #343a40;
    color: white;
    padding: 2rem 0;
    text-align: center;
    position: relative;
}

.auth-button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    padding: 8px;
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.auth-button:hover {
    background: #c82333;
}

.upload-section {
    text-align: center;
    padding: 2rem 0;
}

.upload-button {
    padding: 8px;
    background: #28a745;
    color: white;
    border: none;
    border-radius: 4px;
    margin-left: 10px;
    cursor: pointer;
}

.upload-button:hover {
    background: #218838;
}

.preview-section {
    padding: 2rem 0;
}

.preview-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 20px;
    padding: 20px;
}

.preview-item {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    text-align: center;
    padding: 10px;
}

.preview-canvas {
    width: 100px;
    height: 100px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.preview-item p {
    margin: 5px 0 0;
    font-size: 0.9em;
    color: #343a40;
    word-break: break-all;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
}

footer {
    background-color: #343a40;
    color: white;
    padding: 1rem 0;
    text-align: center;
    margin-top: 2rem;
}

footer a {
    color: white;
    text-decoration: none;
    margin: 0 5px;
}

footer a:hover {
    text-decoration: underline;
}

/* Responsive styles for mobile */
@media (max-width: 768px) {
    /* Navbar */
    .nav {
        padding: 1rem;
        flex-wrap: wrap;
        align-items: center;
    }

    .nav-logo-container {
        position: static;
        margin-right: auto;
    }

    .nav-logo-container img {
        height: 60px;
    }

    .company-name {
        font-size: 1.5rem;
        margin-left: 0.3rem;
    }

    .nav-links {
        display: none;
        flex-direction: column;
        position: fixed;
        top: 0;
        right: 0;
        height: 100vh;
        width: 30%;
        background-color: #FFFFFF;
        padding: 2rem 1rem;
        margin: 0;
        transform: translateX(100%);
        transition: transform 0.3s ease-in-out;
        z-index: 1000;
        box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
    }

    .nav-links.open {
        transform: translateX(0);
        display: flex;
    }

    .nav-link {
        font-size: 1rem;
        margin: 0.5rem 1rem;
        padding: 0.5rem 0;
        border-bottom: 1px solid #E6E6FA;
    }

    .nav-toggle-label {
        display: block;
    }

    .cta-button {
        padding: 0.5rem 1rem;
        font-size: 0.8rem;
        margin: 0.5rem 1rem;
        min-height: 44px;
        border-bottom: none;
    }
}

@media (max-width: 480px) {
    .nav {
        padding: 0.5rem;
    }

    .nav-logo-container img {
        height: 50px;
    }

    .company-name {
        font-size: 1.2rem;
        margin-left: 0.2rem;
    }

    .nav-links {
        width: 40%;
        padding: 1.5rem 0.5rem;
    }

    .nav-link {
        font-size: 0.9rem;
        margin: 0.3rem 1rem;
        padding: 0.3rem 0;
        border-bottom: 1px solid #E6E6FA;
    }

    .cta-button {
        padding: 0.4rem 0.8rem;
        font-size: 0.7rem;
        min-height: 40px;
        margin: 0.3rem 1rem;
        border-bottom: none;
    }

    .nav-toggle-label {
        font-size: 1.2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;IACI,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,sBAAsB;IACtB,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,MAAM;AACV;;AAEA;IACI,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,sEAAsE;IACtE,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sEAAsE;AAC1E;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX;QACI,aAAa;QACb,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,MAAM;QACN,QAAQ;QACR,aAAa;QACb,UAAU;QACV,yBAAyB;QACzB,kBAAkB;QAClB,SAAS;QACT,2BAA2B;QAC3B,sCAAsC;QACtC,aAAa;QACb,yCAAyC;IAC7C;;IAEA;QACI,wBAAwB;QACxB,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,iBAAiB;QACjB,gCAAgC;IACpC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,iBAAiB;QACjB,gCAAgC;IACpC;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Bubblegum+Sans&display=swap');\n\nbody {\n    background-color: #FFFFFF;\n    margin: 0;\n}\n\n.nav {\n    background-color: #FFFFFF;\n    padding: 2rem;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid black;\n    position: relative;\n    margin: 0;\n    width: 100vw;\n    box-sizing: border-box;\n    left: 0;\n    right: 0;\n}\n\n.nav-logo-container {\n    display: flex;\n    align-items: center;\n    position: absolute;\n    left: 1rem;\n    top: 0;\n}\n\n.nav-logo-container img {\n    display: block;\n    background: transparent;\n}\n\n.company-name {\n    font-family: 'Bubblegum Sans', sans-serif;\n    font-size: 2rem;\n    font-weight: 400;\n    color: #2D3E50;\n    margin-left: 0.5rem;\n}\n\n.nav-links {\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n    margin-right: 1rem;\n}\n\n.nav-right {\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n    margin-right: 1rem;\n}\n\n.nav-link {\n    color: #2D3E50;\n    margin: 0 1rem;\n    text-decoration: none;\n    font-size: 1rem;\n}\n\n.nav-link:hover {\n    text-decoration: none;\n}\n\n.logout-link {\n    margin-right: 1rem;\n}\n\n.cta-button {\n    padding: 0.3rem 1rem;\n    border: none;\n    border-radius: 8px;\n    font-size: 0.7rem;\n    font-weight: bold;\n    color: white;\n    background: linear-gradient(90deg, #ffcc99, #ff9966, #ff66cc, #cc66ff);\n    cursor: pointer;\n    margin-left: 1rem;\n}\n\n.cta-button:hover {\n    background: linear-gradient(90deg, #cc66ff, #ff66cc, #ff9966, #ffcc99);\n}\n\n/* Hamburger menu styles */\n.nav-toggle-label {\n    display: none;\n    font-size: 1.5rem;\n    color: #2D3E50;\n    cursor: pointer;\n}\n\n.nav-toggle-label.open::after {\n    content: \"✕\";\n    font-size: 1.5rem;\n}\n\n.header {\n    background-color: #343a40;\n    color: white;\n    padding: 2rem 0;\n    text-align: center;\n    position: relative;\n}\n\n.auth-button {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    padding: 8px;\n    background: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.auth-button:hover {\n    background: #c82333;\n}\n\n.upload-section {\n    text-align: center;\n    padding: 2rem 0;\n}\n\n.upload-button {\n    padding: 8px;\n    background: #28a745;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    margin-left: 10px;\n    cursor: pointer;\n}\n\n.upload-button:hover {\n    background: #218838;\n}\n\n.preview-section {\n    padding: 2rem 0;\n}\n\n.preview-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: 20px;\n    padding: 20px;\n}\n\n.preview-item {\n    background-color: white;\n    border-radius: 10px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    text-align: center;\n    padding: 10px;\n}\n\n.preview-canvas {\n    width: 100px;\n    height: 100px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n.preview-item p {\n    margin: 5px 0 0;\n    font-size: 0.9em;\n    color: #343a40;\n    word-break: break-all;\n}\n\n.container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 1rem;\n}\n\nfooter {\n    background-color: #343a40;\n    color: white;\n    padding: 1rem 0;\n    text-align: center;\n    margin-top: 2rem;\n}\n\nfooter a {\n    color: white;\n    text-decoration: none;\n    margin: 0 5px;\n}\n\nfooter a:hover {\n    text-decoration: underline;\n}\n\n/* Responsive styles for mobile */\n@media (max-width: 768px) {\n    /* Navbar */\n    .nav {\n        padding: 1rem;\n        flex-wrap: wrap;\n        align-items: center;\n    }\n\n    .nav-logo-container {\n        position: static;\n        margin-right: auto;\n    }\n\n    .nav-logo-container img {\n        height: 60px;\n    }\n\n    .company-name {\n        font-size: 1.5rem;\n        margin-left: 0.3rem;\n    }\n\n    .nav-links {\n        display: none;\n        flex-direction: column;\n        position: fixed;\n        top: 0;\n        right: 0;\n        height: 100vh;\n        width: 30%;\n        background-color: #FFFFFF;\n        padding: 2rem 1rem;\n        margin: 0;\n        transform: translateX(100%);\n        transition: transform 0.3s ease-in-out;\n        z-index: 1000;\n        box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);\n    }\n\n    .nav-links.open {\n        transform: translateX(0);\n        display: flex;\n    }\n\n    .nav-link {\n        font-size: 1rem;\n        margin: 0.5rem 1rem;\n        padding: 0.5rem 0;\n        border-bottom: 1px solid #E6E6FA;\n    }\n\n    .nav-toggle-label {\n        display: block;\n    }\n\n    .cta-button {\n        padding: 0.5rem 1rem;\n        font-size: 0.8rem;\n        margin: 0.5rem 1rem;\n        min-height: 44px;\n        border-bottom: none;\n    }\n}\n\n@media (max-width: 480px) {\n    .nav {\n        padding: 0.5rem;\n    }\n\n    .nav-logo-container img {\n        height: 50px;\n    }\n\n    .company-name {\n        font-size: 1.2rem;\n        margin-left: 0.2rem;\n    }\n\n    .nav-links {\n        width: 40%;\n        padding: 1.5rem 0.5rem;\n    }\n\n    .nav-link {\n        font-size: 0.9rem;\n        margin: 0.3rem 1rem;\n        padding: 0.3rem 0;\n        border-bottom: 1px solid #E6E6FA;\n    }\n\n    .cta-button {\n        padding: 0.4rem 0.8rem;\n        font-size: 0.7rem;\n        min-height: 40px;\n        margin: 0.3rem 1rem;\n        border-bottom: none;\n    }\n\n    .nav-toggle-label {\n        font-size: 1.2rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
